export default [
    {
        path: '',
        name: 'pageVisionMissionRouter',
        component: () => import('./page-vision-mission')
    }
]